// import "./BusinessList1.css";
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../Notification";
import { CSVLink } from "react-csv";
function BusinessList() {
    const Navigate = useNavigate();
    const [searchData, setsearchData] = useState('');
    const [items, setItems] = useState([]);
    // const [posts, setPosts] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [delBusinessList, setdelBusinessList] = useState('');
    const [isChecked, setisChecked] = useState(false);
    // const [sorting, setSorting] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' });

    const [sortToggle, setSortToggle] = useState(true);
    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE)
    const [viewMoreData, setviewMoreData] = useState([]);
    const [currPlanData, setCurrPlanData] = useState({});
    const [totalBoughtContacts, setTotalBoughtContacts] = useState();
    const [totalContacts, setTotalContacts] = useState();

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [expiredPlanData, setExpiredPlanData] = useState(items);

    // let perPage = 2;
    // let currentPage="";


   const getBusinessList = async () => {

    const res = await Axios.get(`api/business/list-buisness?pageNo=1&perPage=${perPage}`)

    const data = res?.data?.data || [];
    setItems(data);

    setTotalPage(res?.data?.total_page || 0);

    setpageCount(Math.ceil(res?.data?.data?.totalPage || 0));

    console.log(totalPages)

    setLoading(false)

    localStorage.removeItem('sort_key');
    localStorage.removeItem('sort_order');
};
    useEffect(() => {

        getBusinessList();
    }, [perPage]);

    if (loading && items.length === 0) {
        return <h2>Loading...</h2>
    }
    const fetchBusinessList = async (currentPage) => {

        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if (sort_key && sort_order) {
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/business/list-buisness?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`)
        await setItems(res.data.data.data);
        return items;
    };

    // const handlePageClick = async (items) => {
    //     let currentPage = items.selected + 1;
    //     await fetchBusinessList(currentPage);
    // };
    const handlePageClick = async (items) => {
        console.log(items.selected);

        let currentPage = items.selected + 1;
        const searchBy = document.getElementById("search_by_id").value;
        if (searchData !== "" && searchBy !== "") {

            await searchHandle(currentPage);

        } else {

            await fetchBusinessList(currentPage);
        }
    };
    const handleChange = (e) => {
        // alert("Hi");
        const { name, checked } = e.target;

        if (name === "allSelect") {
            let tempItems = items.map((businessList) => {
                return { ...businessList, isChecked: checked };
            });
            //   console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);
        }
        else {
            let tempItems = items.map((businessList) =>
                businessList.business_id === name ? { ...businessList, isChecked: checked } : businessList
            );
            // console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);

        }
    }
    const alldelete = async (e) => {

        const status = e.target.value
        let bussDataLength = isChecked.length;
        let businessIdArray = [];
        if (bussDataLength > 0) {
            for (let i = 0; i < bussDataLength; i++) {
                console.log(isChecked[i]);
                if (isChecked[i].isChecked === true) {
                    let businessID = isChecked[i].business_id;
                    businessIdArray.push({ business_id: businessID });
                    console.log('ravi', businessIdArray)
                }
            }
        }

        if (isChecked) {
            const res = await Axios.post(`api/business/update-business-status`, { business_id: businessIdArray, action_status: status });
            setdelBusinessList(res.data)
            console.log(delBusinessList);

            // setTimeout(()=>{
            //     alert("Business has been deleted successfully!")
            //     // navigate(`/businessList`);
            // }, 1000);
            setNotify({
                isOpen: true,
                messsage: `Business has been ${status} successfully!`,
                type: 'success',

            })
            // window.location.reload();

        }
        else {
            alert("please Select at least one check box !");
            //console.log("hii");
        }
    }


    const searchHandle = async (currentPage) => {
        // console.log("heelo",currentPage);
        const searchBy = document.getElementById("search_by_id").value;
        if (searchData !== "" && searchBy !== "") {
            const res = await Axios.get(`api/business/list-buisness?pageNo=${currentPage}&perPage=${perPage}&searchData=${searchData}&search_by=${searchBy}`)

            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data)
                setTotalPage(res.data.data.totalPage)
                setpageCount(Math.ceil(res.data.data.totalPage));
            }
            if (res.data.data.data.length <= 0) {
                setItems([]);
                setTotalPage(res.data.data.totalPage)
                setpageCount(Math.ceil(res.data.data.totalPage));
            }

        } else {
            setNotify({
                isOpen: true,
                messsage: `Search By and Search Value Should Not Be Blank!`,
                type: 'error',

            })
        }

    }



    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/business/list-buisness?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);
                // setSortToggle(true);
            }
        }
    }

    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/business/list-buisness?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);



            }
        }
    }
    const viewMore = async (business_id) => {
        alert('hii');
        const status = business_id;
        console.log('hii', status);
        const res = await Axios.get(`api/business/list-buisness?business_id=${business_id}`)
        setviewMoreData(res.data.data.data[0])
        console.log(res.data.data.data[0]);
    }

    const HandleApproved = async (e) => {
        let busiId = e.target.value;
        let busiMobile = e.target.name;
        Axios.post("api/business/approve-business", {
            bussiness_id: busiId,
            business_mobile_no: busiMobile
        })
            .then((res) => {
                getBusinessList();
            })
    }

    const updateCredential = async (e, index) => {
        console.log("this is ", e.target.value, items[index].business_name);
        Navigate(`/insert-whatsapp-credential?business_id=${e.target.value}&business_name=${items[index].business_name}`)
    }


    const verifyOTP = async (e) => {
        let busiId = e.target.value;
        let busiMobile = e.target.name;
        console.log(busiMobile, busiId);

        const res = await Axios.post("api/business/verify-business", {
            bussiness_id_no: busiId,
            business_mobile_no: busiMobile
        })
        console.log(res);
    }
    const handleSuspendedActive = (e, status) => {
        Axios.post(`api/business/suspendedActive-business?business_id=${e.target.value}&status=${status}`)
            .then((res) => {
                console.log(res);
                getBusinessList();
            })
            .catch((error) => {
                console.log(error);
            })
    }


    const viewBusinessDatafun = (business_id) => {
        Axios.get(`api/bussiness/view-business-data?business_id=${business_id}`)
            .then((response) => {
                console.log(response.data.data);
                setCurrPlanData(response.data.data.getCurrPlanData);
                setTotalBoughtContacts(response.data.data.total_bought);
                setTotalContacts(response.data.data.total_contacts);
            })
            .catch((error) => {
                console.log(error);
            })
    }


    const handleStartEndDateData = async () => {
        console.log(startDate);
        console.log(endDate);
        if (startDate && endDate) {
            setSortToggle(false);
            let sortkey = localStorage.getItem("sort_key")
            let order = localStorage.getItem("sort_order")
            console.log(startDate, endDate)
            const res = await Axios.get(`api/business/list-buisness?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}&start_date=${startDate}&end_date=${endDate}`);
            setItems(res.data.data.data);
        }
    }


    const camelCase = str => {
        return str.substring(0, 1).toUpperCase() + str.substring(1);
    };

    const filterColumns = items => {
        // Get column names
        const columns = Object.keys(items?.[0] || {});
        let headers = [];
        columns.forEach((col, idx) => {
            if (col !== "approved_by" && col !== "otp_verify_number" && col !== "district_id" && col !== "state_name" && col !== "state_id" && col !== "country_name" && col !== "city_name" && col !== "modified_date" && col !== "business_type_name" && col !== "business_type_id" && col !== "country_id" && col !== "district_name" && col !== "address" && col !== "date_time_stamp") {
                // OR if (idx !== 0)
                headers.push({ label: camelCase(col), key: col });
            }
        });

        return headers;
    };

    const filterColumnsForExpired = items => {
        // Get column names
        const columns = Object.keys(items?.[0] || {});
        let headers = [];
        columns.forEach((col, idx) => {
            if (col !== "approved_by" && col !== "otp_verify_number" && col !== "district_id" && col !== "state_name" && col !== "state_id" && col !== "country_name" && col !== "city_name" && col !== "modified_date" && col !== "business_type_name" && col !== "business_type_id" && col !== "country_id" && col !== "district_name" && col !== "address" && col !== "date_time_stamp") {
                // OR if (idx !== 0)
                headers.push({ label: camelCase(col), key: col });
            }
        });

        return headers;
    };

    const HandleExpiredPlanExcel = async () => {
        let tempArr = [];
        for (let i = 0; i < items.length; i++) {
            console.log(items.plan_action);
            if (items[i].plan_action == "Stop") {
                tempArr.push(items[i]);
            }
        }
        setExpiredPlanData(tempArr);
    }

    const handleDownloadDocument = (path) => {
        path = process.env.REACT_APP_GCP_BUCKET_URL + path;
        const link = document.createElement('a');
        link.href = path;
        link.download = path.split('/').pop(); // Extract the filename from the path
        // Add the link to the DOM and simulate a click to trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the link element
        document.body.removeChild(link);
    }

    const handleRequestDocument = (business_id) => {
        Axios.post(`api/admin/request-business-document?business_id=${business_id}`)
            .then((res) => {
                console.log(res);
                if (res.status == 200) {
                    getBusinessList();
                    setNotify({
                        isOpen: true,
                        messsage: `${res.data.message}`,
                        type: 'success',
                    })
                }
            })
            .catch((err) => {
                console.log(err);
                if (err.response.status == 422) {
                    setNotify({
                        isOpen: true,
                        messsage: `${err.response.data.message}`,
                        type: 'error',
                    })
                }
            })
    }


    // const insertContactsPayment = async (e, index) => {
    //     // console.log("this is ", e.target.value, items[index].business_name);
    //     Navigate(`/insert-contacts-payment?business_id=${e.target.value}&business_name=${items[index].business_name}`)
    // }


    // const insertPlansPayment = async (e, index) => {
    //     console.log("this is ", e.target.value, items[index].business_name);
    //     Navigate(`/insert-plans-payment?business_id=${e.target.value}&business_name=${items[index].business_name}`)
    // }
    return (
        <>
            <div className="content-page">
                <div className="content">

                    {/* <h1>{totalPages}</h1> */}
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Business List</h4>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">
                            <div className="col-md-6">
                                <div className="business_head">
                                    <button className="btn btn-danger" type="button" value="Deleted" onClick={(e) => alldelete(e)} >DELETE</button>
                                    <button className="btn btn-primary" type="button" value="Active" onClick={(e) => alldelete(e)}  >Active All</button>
                                    <button className="btn btn-primary" type="button" value="Inactive" onClick={(e) => alldelete(e)}>Inactive All</button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="business_head">
                                    {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }         <span><b>Search By :- </b></span>
                                    <select name="search_by" id="search_by_id">
                                        <option value="">Select</option>
                                        <option value="business_id">Business ID</option>
                                        <option value="business_name">Business Name</option>
                                        <option value="business_mobile_no">Business mobile No</option>
                                        <option value="business_email_id">Business Email Id</option>

                                    </select>

                                    <input type="" className='search-business-list' placeholder='Search...'
                                        onChange={(e) => setsearchData(e.target.value)}
                                    />
                                    <button type="Search" className="find-list" onClick={searchHandle}>Search</button>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div className="start-date">
                                    <label for="" >start date:-</label>
                                    <input type="date" id="" name="" onChange={(e) => setStartDate(e.target.value)} />&nbsp;&nbsp;

                                    <label for="" >End date:-</label>
                                    <input type="date" id="" name="" onChange={(e) => setEndDate(e.target.value)} />&nbsp;&nbsp;
                                    <button onClick={handleStartEndDateData}>submit</button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="excle-btn">
                                    <CSVLink data={items} headers={filterColumns(items)} filename={"business-data.csv"}>Download Excel</CSVLink>
                                    <CSVLink data={expiredPlanData} onClick={HandleExpiredPlanExcel} headers={filterColumnsForExpired(expiredPlanData)} filename={"business-Expired-plan.csv"}>Expired Plan</CSVLink>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="tble-row table-responsive">
                                    <table id="datatable" className="table table-bordered business_tb  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th><input
                                                    type="checkbox"
                                                    // business_id="allSelect" 
                                                    name="allSelect"
                                                    checked={!items.some((businessList) => businessList?.isChecked !== true)}
                                                    onChange={handleChange} /> <label className="form-check-label ms-2">All Select</label></th>

                                                <th>S.No</th>
                                                <th >Business_id
                                                    {sortToggle ? (
                                                        <i id="business_id_up" onClick={() => handleSortasc("business_id", 'asc', 'business_id_up')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i id="business_id_down" onClick={() => handleSortdesc("business_id", 'desc', 'business_id_down')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>

                                                <th >Business Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>

                                                <th >Business mobile No.
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_mobile_no", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_mobile_no", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>



                                                <th >Business Email_id
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_email_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_email_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>

                                                <th >Business Contact Person
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_contact_person", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_contact_person", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>

                                                <th >Status
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("status", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("status", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>

                                                <th>
                                                    Action
                                                </th>
                                                <th>
                                                    View More
                                                </th>
                                                <th>
                                                    FB-Credential
                                                </th>
                                                <th>
                                                    Insert Payment
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {items.map((businessList, index) =>
                                                <tr key={index}>
                                                    <td><input
                                                        type="checkbox"
                                                        name={[businessList.business_id]}
                                                        checked={businessList?.isChecked || false}
                                                        onChange={handleChange}
                                                    />  </td>
                                                    <td>{index + 1}</td>
                                                    <td>{businessList.business_id}</td>
                                                    <td>{businessList.business_name}</td>
                                                    <td>{businessList.business_mobile_no}</td>
                                                    <td>{businessList.business_email_id}</td>
                                                    <td>{businessList.business_contact_person}</td>

                                                    <td>{businessList.status}</td>

                                                    <td>
                                                        {/* {
                                                            businessList.approved_date !== undefined ?
                                                                <>Approved</> :
                                                                <button type="button" className="btn btn-primary" value={businessList.business_id} name={businessList.business_mobile_no} onClick={(e) => HandleApproved(e)}>Approve</button>
                                                        } */}
                                                        {
                                                            businessList.status !== "Suspended" ?
                                                                <button type="button" className="btn btn-primary" value={businessList.business_id} onClick={(e) => handleSuspendedActive(e, "Suspended")}>Suspend</button>
                                                                :
                                                                <button type="button" className="btn btn-primary" value={businessList.business_id} onClick={(e) => handleSuspendedActive(e, "Active")}>Active</button>

                                                        }
                                                        {
                                                            businessList.status === "Pending" ?
                                                                <button type="button" className="btn btn-primary" value={businessList.business_id} name={businessList.business_mobile_no} onClick={(e) => verifyOTP(e)}>Verify OTP</button>
                                                                :
                                                                ""

                                                        }



                                                        <button
                                                            type="button" className="btn btn-primary"
                                                            data-toggle="modal"
                                                            data-target="#exampleModalCenter2"
                                                            value={businessList.business_id}
                                                            onClick={(e) => viewBusinessDatafun(e.target.value)}
                                                        >
                                                            View Business Data</button>
                                                        {
                                                            businessList.status === 'Unapprove' || businessList.status === "Pending" ?
                                                                <button type="button" className="btn btn-primary" value={businessList.business_id} name={businessList.business_mobile_no} onClick={(e) => HandleApproved(e)}>Approve</button>
                                                                : <>Approved</>
                                                        }

                                                        {
                                                            businessList.document_path ?
                                                                <button type="button" className="btn btn-primary" value={businessList.business_id} onClick={(e) => handleDownloadDocument(businessList.document_path)}>download document</button>
                                                                :
                                                                <button type="button" className="btn btn-primary" value={businessList.business_id} onClick={(e) => handleRequestDocument(e.target.value)}>request document</button>
                                                        }

                                                    </td>
                                                    <td><button
                                                        type="button" className="btn btn-primary"
                                                        data-toggle="modal"
                                                        data-target="#exampleModalCenter"
                                                        value={businessList.business_id}
                                                        onClick={(e) => viewMore(e.target.value)}
                                                    >
                                                        View More</button></td>
                                                    <td><button
                                                        type="button" className="btn btn-primary"
                                                        value={businessList.business_id}
                                                        onClick={(e) => updateCredential(e, index)}
                                                    >
                                                        Update Credential</button></td>
                                                    {/* <td><button type="button" className="btn btn-primary" value={businessList.business_id} onClick={(e) => insertContactsPayment(e, index)}>Contact Payment</button>
                                                        <button type="button" className="btn btn-primary" value={businessList.business_id} onClick={(e) => insertPlansPayment(e, index)}>Plan Payment</button>
                                                    </td> */}
                                                </tr>)}
                                        </tbody>
                                    </table>



                                    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">BUSINESS LIST</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <p><strong>Business_id :- {viewMoreData.business_id}</strong></p>
                                                                <p><strong>Business Name :- {viewMoreData.business_name}</strong></p>
                                                                <p><strong>Business mobile No. :- {viewMoreData.business_mobile_no}</strong></p>
                                                                <p><strong>Business Email_id :- {viewMoreData.business_email_id}</strong></p>
                                                                <p><strong>Business Contact Person :- {viewMoreData.business_contact_person}</strong></p>
                                                                <p><strong>Business Type ID :- {viewMoreData.business_type_id}</strong></p>
                                                                <p><strong>Business Type Name :- {viewMoreData.business_type_name}</strong></p>
                                                                <p><strong>Business Website :- {viewMoreData.business_website}</strong></p>
                                                                <p><strong>Country_id :- {viewMoreData.country_id}</strong></p>
                                                                <p><strong>Country Name :- {viewMoreData.country_name}</strong></p>
                                                            </div>

                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <p><strong>State_id :- {viewMoreData.state_id}</strong></p>
                                                                <p><strong>State Name :- {viewMoreData.state_name}</strong></p>
                                                                <p><strong>District_id :- {viewMoreData.district_id}</strong></p>
                                                                <p><strong>District Name :- {viewMoreData.district_name}</strong></p>
                                                                <p><strong>City Name :- {viewMoreData.city_name}</strong></p>
                                                                <p><strong>Address :- {viewMoreData.address}</strong></p>
                                                                <p><strong>Approved Date :- {viewMoreData.approved_date}</strong></p>
                                                                <p><strong>Modified Date :- {viewMoreData.modified_date}</strong></p>
                                                                <p><strong>Added Date :- {viewMoreData.added_date}</strong></p>
                                                                <p><strong>Approved By :- {viewMoreData.approved_by}</strong></p>
                                                                <p><strong>Status :- {viewMoreData.status}</strong></p>
                                                                <p><strong>Plan Action :- {viewMoreData.plan_action}</strong></p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="modal fade" id="exampleModalCenter2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">BUSINESS DATA</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <h1>Plan Info</h1>
                                                                <p><strong>Business_id :- {currPlanData.business_id}</strong></p>
                                                                <p><strong>Business Name :- {currPlanData.business_name}</strong></p>
                                                                <p><strong>Plan ID :- {currPlanData.plan_id}</strong></p>
                                                                <p><strong>Bought Plan ID :- {currPlanData.bought_plan_id}</strong></p>
                                                                <p><strong>Package :- {currPlanData.package_name}</strong></p>
                                                                <p><strong>Total Message. :- {currPlanData.total_message}</strong></p>
                                                                <p><strong>Left Message :- {currPlanData.left_message}</strong></p>
                                                                <p><strong>Buy Contacts on this Plan :- {currPlanData.no_of_buy_contacts}</strong></p>
                                                                <p><strong>Status :- {currPlanData.status}</strong></p>
                                                                <p><strong>Subscription :- {currPlanData.subscription_type}</strong></p>
                                                                <p><strong>Expiry :- {currPlanData.expiry_date}</strong></p>
                                                                <p><strong>Price :- {currPlanData.available_amount}</strong></p>
                                                            </div>

                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <p><strong>Total Bought Contacts :- {totalBoughtContacts}</strong></p>
                                                                <p><strong>Total Contacts :- {totalContacts}</strong></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                                <button type="button" className="btn btn-primary">Save changes</button>
                                            </div> */}
                                            </div>
                                        </div>
                                    </div>



                                    <ReactPaginate
                                        previousLabel={"previous"}
                                        nextLabel={"next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination justify-content-center"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                    <div className="slect-pg-row">

                                        <span><b>Rows per page :- </b></span>
                                        <select name="Rows per page" className="item-page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option value="">Select Item Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>

            {/* <!-- end content --> */}

        </>
    );
}

export default BusinessList;